export class Attribute {
  constructor(
    public readonly name: string,
    public readonly type: AttributeType,
    public readonly values?: string[],
  ) {}
}

export const AttributeType = {
  TEXTUAL: "textual",
  NUMERICAL: "numerical",
  CATEGORICAL: "categorical",
} as const;

export type AttributeType = typeof AttributeType[keyof typeof AttributeType];
